export function getExtCost(quantity, eaCost) {
    return Number(quantity * eaCost);
}